import { useState, useEffect } from 'react';
import Slide from '../../utils/Slide';
import { useCarousel } from '../../hooks/useCarousel';
import { ChevronLeft, ChevronRight, PauseIcon, Play } from 'lucide-react';

const slides = [
  {
    image: '/images/categories-hero-banners/categories-slide-1.min.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-1-mobile.min.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide One</h1> */}
        {/* <p className="text-sm mt-2">Enjoy deals on home products</p> */}
      </>
    ),
  },
  {
    image: '/images/categories-hero-banners/categories-slide-2.min.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-2-mobile.min.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide Two</h1>
        <p className="text-sm mt-2">Explore electronics & more</p> */}
      </>
    ),
  },
  {
    image: '/images/categories-hero-banners/categories-slide-3.min.svg',
    imageMobile:
      '/images/categories-hero-banners/categories-slide-3-mobile.min.svg',
    content: (
      <>
        {/* <h1 className="text-3xl font-bold">Slide Two</h1>
        <p className="text-sm mt-2">Explore electronics & more</p> */}
      </>
    ),
  },
];

export default function HeroBanner({
  slides = [],
  height = 360,
  mobileAspectRatio,
  desktopAspectRatio,
  autoSlideInterval = 3000,
  categoriesBanner,
}) {
  const { currentIndex, nextSlide, prevSlide, isPaused, togglePause } =
    useCarousel({ slideCount: slides.length, autoSlideInterval });

  const [containerHeight, setContainerHeight] = useState(height);

  // Slides whose image may be fetched: the visible one plus the next, and
  // any already seen (so they aren't dropped and re-downloaded).
  const [loadable, setLoadable] = useState(() => new Set([0, 1]));
  useEffect(() => {
    const next = (currentIndex + 1) % Math.max(slides.length, 1);
    setLoadable((prev) =>
      prev.has(currentIndex) && prev.has(next)
        ? prev
        : new Set([...prev, currentIndex, next])
    );
  }, [currentIndex, slides.length]);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 768 && mobileAspectRatio) {
        setContainerHeight(Math.round(w * mobileAspectRatio));
      } else if (w >= 768 && desktopAspectRatio) {
        setContainerHeight(Math.round(Math.min(w, 1440) * desktopAspectRatio));
      } else {
        setContainerHeight(height);
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [height, mobileAspectRatio, desktopAspectRatio]);

  return (
    <section className="md:mt-10 mt-8">
      <div
        className="w-full relative overflow-hidden bg-[#F5F5F7]"
        style={{ height: containerHeight }}
      >
        {slides.map((slide, index) =>
          slide?.link ? (
            <a key={index} href={slide?.link}>
              <Slide
                slide={slide}
                isActive={index === currentIndex}
                categoriesBanner={categoriesBanner}
                shouldLoad={loadable.has(index)}
                priority={index === 0}
              />
            </a>
          ) : (
            <Slide
              key={index}
              slide={slide}
              isActive={index === currentIndex}
              categoriesBanner={categoriesBanner}
              shouldLoad={loadable.has(index)}
              priority={index === 0}
            />
          )
        )}

        <div className="absolute bottom-4 right-4 flex gap-2 z-20">
          <button
            aria-label="previous"
            onClick={prevSlide}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            <ChevronLeft size={10} />
          </button>
          <button
            aria-label="next"
            onClick={nextSlide}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            <ChevronRight size={10} />
          </button>
          <button
            aria-label="play or pause"
            onClick={togglePause}
            className="w-8 h-[22px] bg-white rounded-[10px] flex items-center justify-center"
          >
            {!isPaused ? (
              <PauseIcon size={10} fill="black" />
            ) : (
              <Play size={10} fill="black" />
            )}
          </button>
        </div>
      </div>
    </section>
  );
}
